import { useSelector } from 'react-redux';
import { getSucceededCooperationForm, isAuthed, isGuest } from 'redux/query';
import { useContext } from 'react';
import { InsuranceContainerContext } from 'Container/InsuranceContainer/InsuranceContainerContext';

export const useInsuranceFormType = () => {
  const { offerId } = useContext(InsuranceContainerContext);

  const isAuthedUser = useSelector(isAuthed);
  const isGuestUser = useSelector(isGuest);
  const succeededCooperationForm = useSelector(getSucceededCooperationForm);

  // ToDo: add correct user current insurance offers to compare
  if (isAuthedUser && offerId !== succeededCooperationForm) {
    return 'RegisterFormView';
  }
  if (!isAuthedUser && !isGuestUser) {
    return 'OtpView';
  }
  return 'SuccessView';
};
